export default __webpack_public_path__ + "static/fonts/ABCDiatypeRounded-Bold_3MVq0C.woff2";